import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=29857f46&scoped=true&lang=css"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29857f46"]])

export default __exports__